<template>
  <v-container fluid>
    <select-type-school-level-toolbar
        :listType="listType"
        :listSchoolLevel="listSchoolLevel"
        :filterForm="filterForm"/>

    <filter-form :listType="listType"
                 :listSchoolLevel="listSchoolLevel"
                 :allotmentList="allotmentList"
                 :filterForm="filterForm" />

    <v-card>
      <allotment-setting-table
          :listUserAllotment="listUserAllotment"
          :filterForm="filterForm"
          :listOrgLv2MapRowspan="listOrgLv2MapRowspan"
          :allotmentList="allotmentList"/>

<!--      <common-no-result-->
<!--          v-if="!loading && totalItem === 0"-->
<!--      />-->

      <v-row>
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
          <v-pagination
              v-if="totalItem > limit"
              v-model="currentPage"
              class="justify-sm-end"
              :length="getTotalItem(totalItem)"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import AllotmentSettingTable from './components/AllotmentSettingTable'
import SelectTypeSchoolLevelToolbar from './components/SelectTypeSchoolLevelToolbar'
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import FilterForm from "./components/FilterForm";
import AllotmentRepository from "@/repositories/AllotmentRepository";
const UserRepository = RepositoryFactory.get('user');
const DepartmentRepository = RepositoryFactory.get('department');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const TypeRepository = RepositoryFactory.get('type')
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  components: {
    FilterForm,
    AllotmentSettingTable,
    SelectTypeSchoolLevelToolbar
  },
  data() {
    return {
      filterForm: {
        store: '',
        assignContact: 0,
        name: '',
        openMenu: false,
        allotmentId: '',
        schoolLevelId: '',
        typeId: ''
      },
      users: [],
      totalItem: 0,
      currentPage: 1,
      limit: 1000,
      loading: false,
      departmentList: [],
      groupUsers: [],
      allotmentList: [],
      listUserAllotment: [],
      contactStatusList: [],
      listSchoolLevel: [],
      listType: [],
      listOrgLv2: [],
      listOrgLv2MapRowspan: {}
    };
  },
  async created() {
    await Promise.all([
      this.getContactStatusList(),
      this.getListType(),
      this.getListSchoolLevel(),
      this.getListAllotment(),
      this.getListOrgLevel2(),
    ])
    this.filterForm.typeId = this.listType[0].id
    this.filterForm.schoolLevelId = this.listSchoolLevel[0].id
    this.getUserAllotmentList()
    // this.getUserListTemp()

    Bus.$on('change-user-allotment-user', (user) => {
      this.changeUserAllotment(user)
    })

    Bus.$on('update-user-allotment-contact', (user) => {
      this.updateUserAllotment(user)
    })

    Bus.$on('change-status-assign-user', (user) => {
      this.changeStatusUserAllotment(user)
    })

    Bus.$on('search-user-allotment-contact', async (filterForm) => {
      this.filterForm = filterForm
      this.currentPage = 1
      this.filterForm.openMenu = false
      await Promise.all([
        this.getListAllotment(),
        this.getContactStatusList(),
        this.getListOrgLevel2(),
      ])
      this.getUserAllotmentList()
    })
  },
  watch: {
    currentPage: {
      handler () {
        this.getUserAllotmentList()
      },
    },
  },
  methods: {
    async getUserAllotmentList() {
      // const loading = this.$loading.show()
      this.appLoadingData(true)
      this.loading = true
      let params = {
        // limit: this.limit,
        // page: this.currentPage - 1,
        store: this.filterForm.store,
        offAssignContact: this.filterForm.assignContact,
        typeId: this.filterForm.typeId ? this.filterForm.typeId : 1,
        schoolLevelId: this.filterForm.schoolLevelId ? this.filterForm.schoolLevelId : 1,
        username: this.filterForm.name,
        allotmentId: this.filterForm.allotmentId,
        isGetMinistrySource: 1
      }
      const response = await OrganizationMachineRepository.listUserByOrgLeve3(params)
      // loading.hide()
      this.appLoadingData(false)
      this.loading = false
      if (response.success) {
        let dataHandle = []
        _.get(response, 'data', []).forEach(department => {
          let { users = [] } = department
          if (users.length) {
            let rowSpan = 0;
            users.forEach((user, index) => {

              //
              user.rowSpan = users.length;
              user.index = index;
              user.ministryId = department.id;
              user.isEditedIndexOfAllotment = false
              user.assignContact = !this.filterForm.assignContact

              // Tinh rowSpan
              rowSpan += user.sources.length ? user.sources.length : 1

              // user.fullName = `${user.lastName} ${user.firstName}`
              user.departmentName = department.name
              user.showEditAllotment = false

              if(user.allotmentId) {
                user.total_m = 0;
                user.total_a = 0;
                user.total_e = 0;

                let allotmentOfUser = {}
                let indexAllotment = this.allotmentList.findIndex(allotment => allotment.id == user.allotmentId)
                if(indexAllotment > -1) {
                  allotmentOfUser = { ...this.allotmentList[indexAllotment] }
                }

                user.sources.forEach((itemS, index) => {
                  // Tinh chi so tong
                  user.total_m += itemS.numberOfContactM;
                  user.total_a += itemS.numberOfContactA;
                  user.total_e += itemS.numberOfContactE;


                  // Lay thong tin trang thai
                  let indexS = this.contactStatusList.findIndex(conS => conS.id === itemS.statusId)
                  if(indexS > -1) {
                    user.sources[index].name = this.contactStatusList[indexS].name
                  } else {
                    user.sources[index].name = ""
                  }
                  user.sources[index]['showEdit'] = {
                    numberOfContactM: false,
                    numberOfContactA: false,
                    numberOfContactE: false
                  }

                  // Check index of allotment is edited
                  let indexSourceOfAllotment = allotmentOfUser.sources.findIndex(source => source.statusId === itemS.statusId)
                  // console.log('allotmentOfUser[indexSourceOfAllotment]: ', allotmentOfUser.sources[indexSourceOfAllotment])
                  // console.log('indexSourceOfAllotment: ', indexSourceOfAllotment)
                  user.sources[index]['isEdited'] = {
                    numberOfContactA: false,
                    numberOfContactM: false,
                    numberOfContactE: false
                  }

                  if(indexSourceOfAllotment > -1) {
                    let propertyCompare = ['numberOfContactA', 'numberOfContactM', 'numberOfContactE']

                    propertyCompare.forEach(prop => {
                      if(allotmentOfUser.sources[indexSourceOfAllotment][prop] != itemS[prop]) {
                        user.sources[index]['isEdited'][prop] = true
                        user.isEditedIndexOfAllotment = true
                      }
                    })
                  }
                })

                user.isRequired = !user.total_m && !user.total_a && !user.total_e
                // add property showEdit
                user.showEdit = {
                  total_m: false,
                  total_a: false,
                  total_e: false
                }
              } else {
                user.sources = [];
              }

              // if(index == 0) {
              //   user.rowSpan = department.users.length
              // }

              dataHandle.push(user)
            })
            department.users[0].rowSpan = rowSpan
          }
        })
        console.log('dataHandle: ', dataHandle)
        this.listUserAllotment = dataHandle
        // convert level 2
        if(this.listOrgLv2 && this.listOrgLv2.length){
          let dataOrgLv2 = {
            // lv2_15: {
            //   index: 0, rowspan: 2, name: 'Dao Tao V2'
            // }
          }
          for(let i = 0; i <this.listOrgLv2.length; i++){
            let itemOrgLv2 = this.listOrgLv2[i]
            if(!dataOrgLv2[`lv2_${itemOrgLv2.orgId}`]){
              dataOrgLv2[`lv2_${itemOrgLv2.orgId}`] = {
                index: -1, rowspan: 0, name: itemOrgLv2.name, userId: 0
              }
            }
            for(let j = 0; j < itemOrgLv2.children.length; j++){
              for(let k = 0; k < dataHandle.length; k++){
                if(dataHandle[k].ministryId == itemOrgLv2.children[j].id ){
                  if(dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].index < 0){
                    dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].index = dataHandle[k].index
                  }
                  if(dataHandle[k].index == 0){
                    dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].rowspan += dataHandle[k].rowSpan
                    if(!dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].userId){
                      dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].userId = dataHandle[k].id
                    }
                  }

                }
              }
            }
          }
          this.listOrgLv2MapRowspan = {}
          for(let _lv2 in dataOrgLv2){
            this.listOrgLv2MapRowspan[`userId${dataOrgLv2[_lv2].userId}`] = {
              rowspan: dataOrgLv2[_lv2].rowspan, name: dataOrgLv2[_lv2].name
            }
          }
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        })
      }
    },
    async updateUserAllotment(user) {

      let sourcesData = user.sources.map(source => {
        return {
          statusId: source.statusId,
          numberOfContactA: +source.numberOfContactA,
          numberOfContactM: +source.numberOfContactM,
          numberOfContactE: +source.numberOfContactE,
        }
      })

      let body = {
        userId: user.id,
        sources: sourcesData,
        allotmentId: user.allotmentId
      }
      // console.log('body: ', body)
      // return
      const response = await AllotmentRepository.updateIndexAllotmentUser(body)
      if (response.success) {
        this.$swal({
          title: 'Cập nhật thành công !',
          confirmButtonText: 'Đồng ý',
        },);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
      this.getUserAllotmentList()
    },
    async changeUserAllotment(user) {
      const body = {
        userId: user.id,
        allotmentId: user.allotmentId ? user.allotmentId : null,
        typeId: this.filterForm.typeId,
        schoolLevelId: this.filterForm.schoolLevelId
      }
      // console.log('body: ', body)
      // return
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const response = await AllotmentRepository.changeAllotmentUser(body)
      // loader.hide();
      this.appLoadingData(false)
      if (response.success) {
        this.$swal({
          title: 'Cập nhật thành công !',
          confirmButtonText: 'Đồng ý',
        },);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
      this.getUserAllotmentList()
    },
    async changeStatusUserAllotment(user) {
      const body = {
        userId: user.id,
        offAssignContact: +(!user.assignContact)
      }
      // console.log('body: ', body)
      // return
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const response = await AllotmentRepository.onOffAllotmentUser(body)
      // loader.hide();
      this.appLoadingData(false)
      if (response.success) {
        this.$swal({
          title: 'Cập nhật thành công !',
          confirmButtonText: 'Đồng ý',
        },);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
      this.getUserAllotmentList()
    },
    async getContactStatusList() {
      // const loading = this.$loading.show();
      this.appLoadingData(true)
      const response = await ContactStatusRepository.list({
        typeId: this.filterForm.typeId ? this.filterForm.typeId : 1,
        schoolLevelId: this.filterForm.schoolLevelId ? this.filterForm.schoolLevelId : 1
      });
      // loading.hide();
      this.appLoadingData(false)
      if (response.success) {
        const contactStatusList = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          _.get(contactStatus, 'data', []).forEach(data => {
            // Lấy danh sách các trạng thái T0, C0 trừ sai số
            if((data.type.includes('T0') || data.type.includes('C0') || data.type.includes('M0')) && data.code !== 'SS' && data.code !== 'C_SS' && data.code !== 'M_SS') {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                name: _.get(data, 'name', 0),
              });
            }
          });
        });
        this.contactStatusList = contactStatusList;
      } else {
        this.contactStatusList = [];
      }
      // console.log('this.contactStatusList: ', this.contactStatusList)
    },
    async getListAllotment() {
      // const loading = this.$loading.show()
      this.appLoadingData(true)
      const params = {
        typeId: this.filterForm.typeId ? this.filterForm.typeId : 1,
        schoolLevelId: this.filterForm.schoolLevelId ? this.filterForm.schoolLevelId : 1
      }
      const res = await AllotmentRepository.listAllotment(params)
      // loading.hide()
      this.appLoadingData(false)

      if (res.success) {
        this.allotmentList = _.get(res, 'data', []);
      }
    },
    async getListSchoolLevel() {
      // const loading = this.$loading.show()
      if(this.$store.state.listSchoolLevelDrawer) {
          this.listSchoolLevel  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
            return
      }
      
      this.appLoadingData(true)
      const res = await SchoolLevelRepository.listTypeSchoolLevel()
      if (res.success) {
        this.listSchoolLevel = _.get(res, 'data', [])
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      // loading.hide()
      this.appLoadingData(false)
    },
    async getListType() {
      const params = {
        limit: 1000
      }

      const response = await TypeRepository.list(params);
      if (response.success) {
        this.listType = _.get(response, 'data', [])
      }
    },
    async getListOrgLevel2() {
      const res = await OrganizationMachineRepository.listOrgLeve2({
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        this.listOrgLv2 = _.get(res, 'data', [])
        console.log('listOrgLv2: ', this.listOrgLv2)
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  },
  beforeDestroy() {
    Bus.$off('change-user-allotment-user')
    Bus.$off('update-user-allotment-contact')
    Bus.$off('change-status-assign-user')
    Bus.$off('search-user-allotment-contact')
  }
};
</script>
